import { render, staticRenderFns } from "./article_publish.vue?vue&type=template&id=f714b24e&"
import script from "./article_publish.vue?vue&type=script&lang=js&"
export * from "./article_publish.vue?vue&type=script&lang=js&"
import style0 from "./article_publish.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports